import EventEmitter from 'eventemitter3'
import AssetsManager from './data/AssetsManager'
import DataManager from './data/DataManager'
import RankingManager from './ranking/RankingManager'
import RankingView from './ranking/RankingView'
import OverView from './view/OverView'

class Main extends EventEmitter{

  // ---------------------------------------------------------------------------------------------------------
	// --	Main
	// ---------------------------------------------------------------------------------------------------------

  constructor(contents){
    super();

    //Windowのロードが終わったらフォント読み込み
    window.onload = this.loadFonts.bind(this);
  }

  loadFonts()
  {
    WebFont.load(
    {
      custom:{families: ['PixelMplus12-Regular', 'PixelMplus12-Bold', 'PixelMplus10-Regular', 'PixelMplus10-Bold', 'BIT']},
      loading: ()=>{},
      active: this.loadAssets.bind(this),
      inactive: ()=>{}
    });
  }

  /**
   * アセット読み込み
   */
  async loadAssets(){

    //Config＆Assets読み込み
    await AssetsManager.init();

    //ランキングマネージャー初期化
    RankingManager.init();
    RankingView.init();

    //オーバー画面初期化
    OverView.init();

    //コンフィグ
    this.config = AssetsManager.getConfig();

    //PIXI初期化
    this.initPIXI();

    //コンテンツ準備
    this.emit('init', {"app":this.app, "root":this.rootContainer});

    //リサイズハンドリング
    window.onresize = this.onResize.bind(this);
    this.onResize();
  }

  /**
   * PIXI.js初期化
   */
  initPIXI()
  {
    //コンフィグ
    this.config = AssetsManager.getConfig();

    //アプリケーション生成
    this.app = new PIXI.Application({
      resolution: 1,
      backgroundColor:0x000000,
      antialias: false,
      transparent: false
    });
    DataManager.setData('app', this.app);


		//DOM配置
		document.body.appendChild(this.app.view);

    //コンテンツ用のコンテナ生成
    this.rootContainer = new PIXI.Container();
    this.app.stage.addChild(this.rootContainer);
    DataManager.setData('root', this.rootContainer);
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ
	// ---------------------------------------------------------------------------------------------------------

  /**
   * リサイズハンドリング
   */
  onResize()
  {
		let width;
		let height;
		let ratioWidth;
		let ratioHeight;
		let ratio;
		
		width = $(window).innerWidth();
		height = $(window).innerHeight();
		ratioWidth = width / this.config.STAGE_WIDTH;
		ratioHeight = height / this.config.STAGE_HEIGHT;
		
    if (ratioWidth < ratioHeight)
    {
      ratio = ratioWidth;
    }
    else
    {
      ratio = ratioHeight;
    }
    
    this.app.view.style.width = Math.floor(this.config.STAGE_WIDTH * ratio) + 'px';
    this.app.view.style.height = height + 'px';
    
    this.app.renderer.resize(this.config.STAGE_WIDTH, Math.round(height/ratio));

    this.emit('resize');
		

    //ゲームリサイズ
		// top.resize({width:renderer.width, height:renderer.height});
		// game.resize({width:renderer.width, height:renderer.height});
 }

	// ---------------------------------------------------------------------------------------------------------
}

export default Main